<template>
	<div>
		<table class="users-list-table table table-primary table-striped">
			<thead>
				<tr>
					<th>UserId</th>
					<th>Email</th>
					<th>Phone Number</th>
					<th>Type</th>
					<th>Code OTP</th>
					<th>Created At</th>
					<th>Remaining Time</th>
				</tr>
			</thead>
			<tbody v-if="otps.length > 0 && !isLoading">
				<tr v-for="(otp, index) in otps" :key="index">
					<td v-for="(value, key) in otp" :key="key" class="text-center">
						<template v-if="key === 'userId' || key === 'email' || key === 'code' || key === 'temp_phone'">
							<div class="d-flex align-items-center mt-1 justify-content-center">
								<div
									class="user__id"
									v-tooltip="'User ID'">
									{{ otp[key] }}
								</div>
								<span class="cursor-pointer text-primary ml-1" v-tooltip="'Copy Text'" @click="copyText(otp[key])">
									<i class="bi bi-clipboard"></i>
								</span>
							</div>
						</template>
						<template v-else-if="key === 'type'">
							<span class="status-pill success text-capitalize">
								{{ otp[key].split('_').join(' ') }}
							</span>
						</template>
						<template v-else-if="key === 'created_at'">
							<span>{{ setFormatTime(otp[key]) }}</span>
						</template>
						<template v-else-if="key === 'remaining_at'">
							<span class="" :class="otp[key] > 60 ? 'success text-success' : 'danger text-danger' ">{{ formatTimeRemaining(otp[key]) }}</span>
						</template>
						<template v-else>
							{{ otp[key] }}
						</template>
					</td>
				</tr>
			</tbody>
			<td v-if="otps.length === 0 || isLoading" colspan="7" style="background-color: #ffff;">
				<div class="table-fetch-status text-center" v-if="isLoading">
					<div class="is-loading large dark m-auto"></div>
				</div>
				<div class="list-empty" v-if="otps.length === 0 && !isLoading">
					<i class="material-icons mr-2">error_outline</i>
					<!-- <span v-if="keyword === ''">There is no users yet.</span> -->
					<span>Tidak Ada Otp Yang Tersedia</span>
				</div>
			</td>
		</table>

	</div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
// import { duplicateVar } from '@/lib/helper';

import { copyToClipboard } from '@/lib/helper';

const utcPlugin = require('dayjs/plugin/utc');
const timezonePlugin = require('dayjs/plugin/timezone');

// Extend dayjs with plugins
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

export default {
	name: 'OtpTable',
	props: {
		otps: {
			type: Array,
			default: () => [],
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
	methods: {
		setFormatTime(date, format = 'YYYY-MM-DD : HH:mm:ss') {
			return dayjs.utc(date).tz(this.user?.timezone).format(format);
		},
		formatTimeRemaining(seconds) {
			const minutes = Math.floor(seconds / 60);
			const secs = seconds % 60;
			return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
		},
		setDiffSeconds(expiredAt) {
			const now = dayjs();
			return now?.diff(expiredAt, 'second');
		},
		copyText(text) {
			copyToClipboard(text);

			this.$notify({
				group: 'app',
				title: 'text Copied',
				text: `${text} Successfully to copied`,
				type: 'success',
			});
		},
	},
	beforeDestroy() {
		// Clear intervals to avoid memory leaks
		this.otps.forEach((otp) => {
			if (otp.countdownInterval) {
				clearInterval(otp.countdownInterval);
			}
		});
	},
};
</script>
